import { Link } from "react-router-dom";

function NotFound() {
  const focusRing =
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 focus-visible:ring-offset-amber-50/50";

  return (
    <div className="min-h-screen bg-amber-50/50 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <h1 className="text-6xl font-bold text-stone-300 mb-4">404</h1>
        <h2 className="text-2xl font-bold text-stone-800 mb-4">Page not found</h2>
        <p className="text-stone-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className={`inline-flex items-center gap-2 bg-brand-orange text-stone-900 px-6 py-3 rounded-full font-semibold hover:bg-brand-orange-hover transition-colors ${focusRing}`}
        >
          Return to homepage
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
